import apiClient from '../apiClient';

const categoriasServices = {
  obtenerCategorias: async () => {
    try {
      const response = await apiClient.get(`/categorias`);

      return response.data;      
    } catch (error) {
      throw error;
    }
  },
  obtenerCategoriaPorId: async (id) => {
    try {
      const response = await apiClient.get(`/categorias/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  actualizarCategoria: async (id, params) => {
    try {
      const response = await apiClient.put(`/categorias/${id}`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearCategoria: async (params) => {
    try {
      const response = await apiClient.post(`/categorias/`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarCategoria: async (id) => {
    try {
      const response = await apiClient.delete(`/categorias/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default categoriasServices;
